import { render } from "./SubmitRankingPublicationModal.vue?vue&type=template&id=7c70ac71&scoped=true"
import script from "./SubmitRankingPublicationModal.vue?vue&type=script&lang=js"
export * from "./SubmitRankingPublicationModal.vue?vue&type=script&lang=js"

import "./SubmitRankingPublicationModal.vue?vue&type=style&index=0&id=7c70ac71&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c70ac71"]])

export default __exports__